import React from "react";
import Header from "./components/Header";
import HeroSlider from "./components/Slider";
import BizKimiz from "./components/BizKimiz";
import Galeri from "./components/Galeri";
import Referanslar from "./components/Referanslar";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Header />
      <HeroSlider />
      <BizKimiz />
      <Galeri />
      <Referanslar />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
